import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import CheckedIconSelected from "../../../../../components/Icons/CheckedIconSelected";
import { IconSort } from "../../../../../components/Icons/IconSort";

import { SORT_TYPE_OPTIONS, SORT_TYPE_PRIME_OPTIONS } from "../../../../../constants";
import { useApp } from "../../../../../contexts";

function Sort(props) {
  const { filterData, type, onChange, language } = props;
  const { T } = useApp();
  const sortOptions = useMemo(() => {
    if (type === 'nft_prime') {
      return SORT_TYPE_PRIME_OPTIONS.map((item) => {
        item.text = T(item.text);
        return item;
      });
    }else{
      return SORT_TYPE_OPTIONS.map((item) => {
        item.text = T(item.text);
        return item;
      })
    }
  }, [language, type])
  const sortDefault = sortOptions.find(
    (item) => item.value == filterData?.sort
  )
  const [show, $show] = useState(false);
  const [sort, $sort] = useState(sortDefault?.value);
  const handleDropdown = () => {
    $show(!show);
  };
  const changeSort = (val) => {
    $sort(val);
    const sortSelected = sortOptions.find((item) => item.value == val);
    $show(false);
    onChange(val);
  };
  return (
    <div className="relative">
      <div
        className="flex justify-center items-center h-[40px] w-[40px] bg-white gap-[8px] rounded-[10px] cursor-pointer"
        onClick={() => handleDropdown()}
      >
        <span className="flex">
          <IconSort />
        </span>
      </div>
      {show && (
        <div className="absolute right-0 top-[40px] z-10 w-[200px] rounded-[15px] shadow-lg bg-white pb-3">
          {sortOptions.map((item) => {
            return (
              <div
                className="flex justify-between items-center py-2.5 px-5 cursor-pointer"
                onClick={() => changeSort(item.value)}
                key={item.value}
              >
                <span
                  className={`text-base ${
                    item.value == sort ? " text-aia-red" : " text-suzu-gray-7"
                  }`}
                >
                  {T(item.text)}
                </span>
                {item.value == sort && <CheckedIconSelected />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

Sort.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func,
};

export default Sort;
